import api from '../api';
import {
  AppBase,
  AppSplitRecipientBankAccountBase,
  AppSplitRecipientBase,
} from '../../models/app';

type BankAccountRequest = {
  account_check_digit: string;
  account_number: string;
  bank: string;
  branch_check_digit?: string;
  branch_number: string;
  holder_document: string;
  holder_name: string;
  holder_type: 'individual' | 'company';
  metadata?: {
    [key: string]: string;
  };
  type: 'checking' | 'savings';
};

type TransferSettings = {
  transfer_enabled: boolean;
  transfer_interval: 'day';
  transfer_day: number;
};

type AnticipationSettings = {
  delay?: string;
  enabled: boolean;
  type: 'full' | '1025';
  volume_percentage: string;
};

type UpdateRecipientProps = {
  id?: string;
  automatic_anticipation_settings?: AnticipationSettings;
  code?: string;
  default_bank_account: BankAccountRequest;
  description?: string;
  document: string;
  email: string;
  metadata?: {
    [key: string]: string;
  };
  name: string;
  transfer_settings?: TransferSettings;
  status: 'active' | 'inactive';
  type: 'individual' | 'company';
};

interface IUpdateAppProps {
  appId: string;
  description?: string;
  hookUrl?: string;
  name: string;
  ref: string;
  splitRecipient?: UpdateRecipientProps;
  storeId?: string;
  usePagarmeProvider: boolean;
}

interface IDetailedAppSplitRecipient extends AppSplitRecipientBase {
  bankAccount: AppSplitRecipientBankAccountBase;
}

export interface IUpdatedApp extends AppBase {
  splitRecipient?: IDetailedAppSplitRecipient;
}

export const updateAppsService = async ({
  appId,
  description,
  hookUrl,
  name,
  ref,
  splitRecipient,
  storeId,
  usePagarmeProvider,
}: IUpdateAppProps): Promise<IUpdatedApp> => {
  const { data } = await api.patch<IUpdatedApp>(`/apps/${appId}`, {
    description,
    hookUrl,
    name,
    ref,
    splitRecipient,
    storeId,
    usePagarmeProvider,
  });

  return data;
};
